import { Quill } from "vue2-editor";

// Only register custom formats once
let registered = false;

export function registerQuillFormats() {
  if (registered) return;
  
  const Link = Quill.import('formats/link');
  
  class MyLink extends Link {
    static create(value) {
      let node = super.create(value);
      value = this.sanitize(value);
      
      // Check if it's an internal link
      if(
        value.startsWith("https://ato.vision") || 
        value.startsWith("https://www.ato.vision") ||
        value.startsWith("/")
      ) {
        node.removeAttribute('target');
      } else if(value.startsWith("https:") || value.startsWith("http:")) {
        node.setAttribute('target', '_blank');
      } else if(value.startsWith("www.")) {
        value = "https://" + value;
        node.setAttribute('target', '_blank');
      } else {
        node.setAttribute('target', '_self');
      }
      
      node.setAttribute('href', value);
      return node;
    }
  }
  
  Quill.register(MyLink, true); // true = suppress warning if already registered
  registered = true;
}










